import styles from '../addProductToChargeStyles.scss';
import { Button } from 'components';
import {
  AddItemType,
  AddProductToChargeDetails,
} from 'lane-shared/domains/billingPayments/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isNumberTwoDecimalPlaces,isNumberThreeDecimalPlaces } from '../../../products-services/helpers/isNumberTwoDecimalPlaces';

export function AddProductButtonGroup({
  productDetails,
  formType,
  addProduct,
  onCancel,
}: {
  productDetails: AddProductToChargeDetails;
  formType: AddItemType | undefined;
  addProduct: Function;
  onCancel: Function;
}) {
  const { t } = useTranslation();
  const isSaveButtonDisabled = () => {
    const {
      productCategoryId,
      productId,
      name,
      rate,
      quantity,
      markup,
      tax,
      adminFee,
    } = productDetails;

    const rateIsInvalid = !isNumberTwoDecimalPlaces(parseFloat(rate));
    const taxIsInvalid =
      tax?.value &&
      ( 
        (tax.type === "TAX_AMOUNT_TYPE_PERCENTAGE" && !isNumberThreeDecimalPlaces(parseFloat(tax.value)))
        ||
        (tax.type === "TAX_AMOUNT_TYPE_FIXED" && !isNumberTwoDecimalPlaces(parseFloat(tax.value)))
      );

    const markupIsInvalid =
      markup?.value && !isNumberTwoDecimalPlaces(parseFloat(markup.value));

    const adminFeeIsInvalid =
      adminFee?.value && !isNumberTwoDecimalPlaces(parseFloat(adminFee.value));

    // Check if rate, tax, or markup are not numbers with two or fewer decimal places
    const invalidDecimalPlaces =
      rateIsInvalid || taxIsInvalid || markupIsInvalid || adminFeeIsInvalid;

    // Check if any of the required fields are missing
    const missingFields =
      !productCategoryId || !rate || !quantity || !markup?.value || !tax?.value;

    // Check if the form type is 'EXISTING' and productId is missing
    const missingProductId = formType === AddItemType.EXISTING && !productId;

    // Check if the form type is 'CUSTOM' and name is missing
    const missingName = formType === AddItemType.CUSTOM && !name;

    // Return true if any of the above conditions are met
    return (
      invalidDecimalPlaces || missingFields || missingProductId || missingName
    );
  };

  return (
    <div className={styles.buttonGroup}>
      <Button
        className={styles.button}
        onClick={() => onCancel()}
        testId="cancelAddProductButton"
      >
        {t('abp.cancel')}
      </Button>
      <Button
        className={styles.button}
        variant="contained"
        onClick={() => addProduct()}
        testId="saveProductButton"
        disabled={isSaveButtonDisabled()}
      >
        {t('Add')}
      </Button>
    </div>
  );
}
